export default "__VITE_ASSET__DeqCuCb4__"